import { render, staticRenderFns } from "./SportsDropdown.vue?vue&type=template&id=4c121132&"
import script from "./SportsDropdown.vue?vue&type=script&lang=ts&"
export * from "./SportsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports